module.exports = __webpack_public_path__ + "img/shiptheory.e7d45d36.png";